import { useLayoutEffect, useState, type RefObject } from 'react';

export default function useFillViewportHeight(elRef: RefObject<HTMLElement | null>, bottomGap = 0): number | undefined {
  const [height, setHeight] = useState<number>();

  useLayoutEffect(() => {
    const update = () => {
      const el = elRef.current;
      if (!el) return;
      // The element may be `position: sticky`: once it is stuck its own rect top is pinned to the
      // sticky offset, so `rect.top + scrollY` would grow with the scroll position and collapse the
      // height. The parent stays in normal flow, so its document top is the element's resting top.
      const anchor = el.parentElement ?? el;
      const top = anchor.getBoundingClientRect().top + window.scrollY;
      setHeight(Math.max(0, Math.floor(window.innerHeight - top - bottomGap)));
    };

    update();
    window.addEventListener('resize', update);
    const ro = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(update);
    const parent = elRef.current?.parentElement;
    if (parent) ro?.observe(parent);
    return () => {
      window.removeEventListener('resize', update);
      ro?.disconnect();
    };
  }, [elRef, bottomGap]);

  return height;
}
